import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-accent-50/40 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-6">
            {t('about.label', 'О СИСТЕМЕ YOYBUY SHEET')}
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-snug mb-12">
            {t('about.title', 'Что такое YOYBUY Spreadsheet и почему это лучший способ покупать из Китая')}
          </h2>

          <div className="space-y-6 text-left">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              {t('about.paragraph1', '')}
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              {t('about.paragraph2', '')}
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              {t('about.paragraph3', '')}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
            <Link
              to="/yoybuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-900 text-foreground-900 font-semibold text-sm whitespace-nowrap transition-all duration-300 hover:bg-foreground-900 hover:text-background-50 cursor-pointer"
            >
              {t('about.btnGuide', 'YOYBUY Sheet: Полное руководство')}
            </Link>
            <Link
              to="/yoybuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-900 text-foreground-900 font-semibold text-sm whitespace-nowrap transition-all duration-300 hover:bg-foreground-900 hover:text-background-50 cursor-pointer"
            >
              {t('about.btnHowTo', 'Как заказать через YOYBUY Sheet')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}